import * as Sentry from '@sentry/react';
import { Replay } from '@sentry/replay';

const SENTRY_DSN = 'https://e0966682956b41d58f3f3720ec7f2713@o4507465517891584.ingest.us.sentry.io/4511097441157120'

const getEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname === 'localhost') {
    return 'development';
  }
  
  if (hostname.indexOf('dev') !== -1) {
    return 'staging';
  }
  
  return 'production';
};

const initSentry = () => {
  const environment = getEnvironment();
  
  // No inicializar Sentry en desarrollo local
  if (environment === 'development') {
    console.log('Sentry disabled for development environment');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: environment,
    integrations: [
      new Replay({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Configuración de rendimiento
    tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
    beforeSend: function(event) {
      // Añadir información del host al evento
      if (event.tags) {
        event.tags.host = window.location.hostname;
        event.tags.platform = navigator.platform;
      } else {
        event.tags = {
          host: window.location.hostname,
          platform: navigator.platform
        };
      }
      return event;
    },
    // Ignorar ciertos errores
    ignoreErrors: [
      // Ignorar errores de red
      /Network request failed/,
      // Ignorar errores de CORS
      /Access to fetch at .* from origin .* has been blocked by CORS policy/
    ]
  });
};

export default initSentry; 